import axios from "axios";
import baseURL from "./utility/baseUrl";
import getToken from "../functions/getToken";

const http = axios.create();

function isExpiredSession(response) {
  return response?.status === 401 && response?.data?.errorCode === 1;
}

function stopIfSessionExpired(response) {
  if (window.location.pathname === "/login") {
    return null;
  }

  if (!isExpiredSession(response)) {
    return null;
  }

  window.location.href = "/login";
  return new Promise(() => {});
}

http.interceptors.response.use(
  function (response) {
    const stopped = stopIfSessionExpired(response);

    if (stopped) {
      return stopped;
    }

    return response;
  },
  function (error) {
    const stopped = stopIfSessionExpired(error?.response);

    if (stopped) {
      return stopped;
    }

    return Promise.reject(error);
  },
);

export async function postMethod(url, body) {
  const data = await http.post(baseURL + url, body).catch(function (error) {
    if (error.response) {
      return error.response;
    }
  });

  return data;
}

export async function postAuthMethod(url, body) {
  const token = getToken();

  const data = await http
    .post(baseURL + url, body, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
    })
    .catch(function (error) {
      if (error.response) {
        return error.response;
      }
    });

  return data;
}

export async function getMethod(url, options = {}) {
  if (url.slice(-1) === "/") {
    url = url.substring(0, url.length - 1);
  }

  const data = await http.get(baseURL + url, { params: options });
  return data;
}

export async function getAuthMethod(url, options = {}, signal = undefined) {
  const token = getToken();
  if (url.slice(-1) === "/") {
    url = url.substring(0, url.length - 1);
  }
  const response = await http
    .get(baseURL + url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      params: options,
      signal: signal,
    })
    .catch(function (error) {
      if (error.response) {
        return error.response;
      }
    });

  return response;
}
export function handleEnter(event) {
  if (event.key === "Enter") {
    const form = event.target.form;
    const index = [...form].indexOf(event.target);

    form[index + 1].focus();
    event.preventDefault();
  }
}

export const putAuthMethod = async (url = "", data, config = undefined) => {
  const token = getToken();

  return http.put(baseURL + url, data, {
    headers: { Authorization: "Bearer " + token },
    ...config,
  });
};
